import React from "react";
import { DoctorWithAddresses } from "../api/models";
import { Identifier } from "./Identifier";

interface DoctorDocplannerLabelProps {
  doctor: DoctorWithAddresses | undefined;
}

export function DoctorDocplannerLabel(props: DoctorDocplannerLabelProps) {
  const { doctor } = props;
  if (!doctor) return null;

  return (
    <span>
      {doctor.doctor?.name} {doctor.doctor?.surname} <Identifier value={doctor.doctor?.id} title="Znany Lekarz" />
    </span>
  );
}
